import { Component, OnInit } from '@angular/core';
import {DeviceService} from "../device.service";
import {Device} from "../../model/device.model";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UserService} from "../../shared/user.service";
import {DeviceType} from "../../model/device-type.model";

@Component({
    selector: 'app-device-view',
    templateUrl: './device-view.component.html',
    standalone: false
})
export class DeviceViewComponent implements OnInit {

  device: Device;
  deviceData: any = {};
  newItem = true;
  isAdmin = false;
  types: DeviceType[];
  configs = [];
  servers: any[] = [];

  constructor(
    private service: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.isAdmin = this.userService.currentUser.isAdmin();
    this.initPage();
    this.fetchOptions();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/device']);
      } else {
        if (id === 'new') {
          this.newItem = true;
          this.device = new Device();
        } else {
          this.newItem = false;
          this.fetchItem(id);
        }
      }
    })
  }

  fetchOptions() {
    this.service.getDeviceOptions().subscribe((resp:any) => {
      if (resp.types) {
        this.types = resp.types.map(r => new DeviceType(r))
      }
      if (resp.typeConfig) {
        this.configs = Object.values(resp.typeConfig);
      }
      if (resp.servers) {
        this.servers = resp.servers;
      }
    })
  }

  fetchItem(id) {
    this.service.getDevice(id).subscribe((resp:any) => {
      if (resp) {
        this.device = new Device(resp);
      }
    })
  }

  onDeviceDataChange(data) {
    this.deviceData = {
      ...this.deviceData,
      ...data
    };
  }
}
